import React from 'react';
// Native MUI Components
import { 
  Card, 
  CardContent, 
  CircularProgress, 
  Typography, 
  Box, 
  Container 
} from '@mui/material';

interface LoadingSpinnerProps {
  text?: string;
  fullPage?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ text = 'Loading...', fullPage = false }) => {
  const spinnerContent = (
    <Box sx={{ textAlign: 'center', py: 6 }}>
      <CircularProgress size={48} sx={{ mb: 2 }} />
      <Typography variant="h6" component="h2" gutterBottom>
        {text}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Please wait a moment.
      </Typography>
    </Box>
  );

  if (fullPage) {
    return (
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        {spinnerContent}
      </Box>
    );
  }

  return (
    <Container maxWidth="md">
      <Card>
        <CardContent>
          {spinnerContent}
        </CardContent>
      </Card>
    </Container>
  );
};

export default LoadingSpinner;
